import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Language extends BaseEntity {
  id: number;
  name: string;
  code: string;
  rank: number;
  constructor() {
    super();
  }
}